import { useCallback } from 'react'
import type { DataNode } from '../types'
import { useContentItemViewNode } from './useContentItemViewNodeService'

/**
 * Custom hook to handle actions related to Article content items
 * @returns Actions related to Article content items
 */
export const useArticleActions = () => {
    const {
        contentItemViewNodes,
        findContentItemNode,
        insertNodeAfterSibling,
        setAddingNode,
        createContentItemViewNode,
    } = useContentItemViewNode()

    /**
     * Adds an Article content item after a sibling content item
     * @param sibling Sibling content item to insert this node after
     */
    const addArticleAfterSibling = useCallback(
        (sibling: DataNode) => {
            const siblingNode = findContentItemNode(sibling.key)

            if (!siblingNode) return

            // Save new node and reorder siblings to Local State
            const articleNode = createContentItemViewNode('', siblingNode)
            insertNodeAfterSibling(articleNode)
            // Set currently being added node to focus
            setAddingNode(articleNode)
        },
        [
            contentItemViewNodes,
            findContentItemNode,
            createContentItemViewNode,
            insertNodeAfterSibling,
        ]
    )

    return { addArticleAfterSibling }
}
